import React, { Component } from 'react';
import {
	Dialog,
	DialogContent,
	DialogTitle,
	DialogHeader,
	DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { IconButton } from '@/components/ui/custom/IconButton';
import { CircleHelp } from 'lucide-react';

const HUMAN_AGENT_TAG = 'HUMAN_AGENT';

class FacebookMessageTagDialog extends Component {
	closeDialog = () => {
		this.props.handleCloseFacebookMessageTagDialog();
	};

	sendMessage = () => {
		this.props.onSendWithHumanAgent?.(HUMAN_AGENT_TAG);

		this.closeDialog();
	};

	renderActions = () => (
		// Phones: full-width buttons stacked with the main action on top.
		<div className="max-md:flex max-md:flex-col-reverse max-md:gap-2 max-md:[&>button]:min-h-11">
			<Button
				variant="outline"
				onClick={this.closeDialog}
				style={{ marginRight: 10 }}
				className="max-md:!mr-0"
			>
				Cancel
			</Button>

			<Button
				onClick={this.sendMessage}
			>
				Send with Human Agent
			</Button>
		</div>
	);

	render() {
		return (
			<Dialog open={this.props.open} onOpenChange={this.closeDialog}>
				<DialogContent>
					<DialogHeader>
						<DialogTitle>
							<div className="flex justify-start items-center space-x-2">
								Facebook Message Tag
								<IconButton
									onClick={() =>
										window.open(
											'http://help.chekkit.io/en/articles/4256858-what-is-a-facebook-message-tag',
											'_blank'
										)
									}
									aria-label="What is a Facebook message tag?"
								className="max-md:size-11"
								>
									<CircleHelp className="size-5 text-muted-foreground" />
								</IconButton>
							</div>
						</DialogTitle>
					</DialogHeader>
					<p className="text-sm">
						This conversation is outside the 24 hour window. We can try
						sending your message using the Human Agent tag (allowed up to
						7 days after the customer’s last message).
					</p>
					<p className="text-xs text-muted-foreground">
						By continuing, you confirm you are not sending promotional
						content (deals, offers, coupons, discounts).
					</p>
					<DialogFooter> {this.renderActions()}</DialogFooter>
				</DialogContent>
			</Dialog>
		);
	}
}

export default FacebookMessageTagDialog;
